const styles = theme => ({
  root: {
    marginBottom:20
  },
});

export default styles;